/**
 * Divider Component
 * Pure presentation component for visual dividers.
 */

export interface DividerProps {
  orientation?: 'horizontal' | 'vertical';
  className?: string;
}

export function Divider({
  orientation = 'horizontal',
  className = '',
}: DividerProps) {
  const baseClasses = 'bg-[var(--surface-border-subtle)]';
  
  const orientationClasses = orientation === 'horizontal'
    ? 'h-px w-full'
    : 'w-px h-full';

  const classes = `${baseClasses} ${orientationClasses} ${className}`.trim();

  return <div className={classes} role="separator" />;
}
